<template>
  <div class="min-h-screen flex items-center justify-center px-6">
    <div class="max-w-md rounded-3xl border border-white/10 bg-midnight-900/80 p-6 text-sm text-steel-300">
      <p class="text-xs uppercase tracking-[0.3em] text-steel-500">{{ $t('authCallback.eyebrow') }}</p>
      <p class="mt-3 text-white">{{ statusMessage }}</p>
      <p v-if="errorMessage" class="mt-3 text-rose-200">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import { supabase } from '@/lib/supabase'

export default {
  name: 'AuthCallback',
  data() {
    return {
      statusMessage: '',
      errorMessage: '',
    }
  },
  created() {
    this.statusMessage = this.$t('authCallback.processing')
  },
  async mounted() {
    try {
      if (window.__drvnAuthProcessing) {
        this.statusMessage = this.$t('authCallback.finalizing')
        return
      }
      window.__drvnAuthProcessing = true

      const hasCode = window.location.search.includes('code=')
      if (hasCode && typeof supabase.auth.exchangeCodeForSession === 'function') {
        let exchangeError = null
        try {
          const { error } = await supabase.auth.exchangeCodeForSession(window.location.href)
          exchangeError = error || null
        } catch (err) {
          exchangeError = err
        }
        if (exchangeError?.name === 'AbortError') {
          // Retry once if the request was aborted by a duplicate caller.
          await new Promise((resolve) => setTimeout(resolve, 200))
          const { error } = await supabase.auth.exchangeCodeForSession(window.location.href)
          exchangeError = error || null
        }
        if (exchangeError) {
          console.error('Error exchanging code for session:', exchangeError)
          this.errorMessage = exchangeError.message || this.$t('authCallback.completeError')
          return
        }
        const { data } = await supabase.auth.getSession()
        if (data?.session) {
          this.statusMessage = this.$t('authCallback.complete')
          window.location.replace('/feed')
          return
        }
        this.errorMessage = this.$t('authCallback.sessionMissing')
        return
      }
      const { data } = await supabase.auth.getSession()
      if (data?.session) {
        this.statusMessage = this.$t('authCallback.complete')
        window.location.replace('/feed')
        return
      }
      this.errorMessage = this.$t('authCallback.missingCode')
    } catch (err) {
      console.error(err)
      this.errorMessage = this.$t('authCallback.unexpected')
      return
    } finally {
      window.__drvnAuthProcessing = false
      const clean = window.location.origin + window.location.pathname
      window.history.replaceState({}, document.title, clean)
    }
  },
}
</script>
